// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__3Zgej","tag__title":"styles_tag__title__3Fbhk"};